<div class="card" [class]="{'invalid-deadweight': isCargoDeltaExceedingDeadWeight()}">
  <div class="card-body p-5">
    <div class="h1 mb-2">Berth details</div>
    <p class="mb-4 enabled">
      Berth names and order are taken from
      <a [routerLink]="['/details', visit().crn, 'visit']"
         class="link-primary text-decoration-underline">
        the timeline</a>.
      Cargo discharge information comes from the
      <a [routerLink]="['/cargo']"
         class="link-primary text-decoration-underline">
         Cargo Inbound service</a>.
    </p>
    @if (isCargoDeltaExceedingDeadWeight()) {
      <app-alert summary="Combined weight exceeds dead weight"
                icon="fa-circle-xmark"
                [severity]="AlertSeverity.DANGER"
                class="mb-4 validation-deadweight">
        Combined weight of all cargo on visit cannot exceed {{ vesselDeadWeightTons() | number: '1.0-3' : 'nl' }} tons
      </app-alert>
    }
    <ol class="event-list">
      @for (berthVisit of selectedDeclaration().visit?.berthVisits; track berthVisit.berthVisitId) {
        <li class="event-list-item">
          <app-berth-visit-rotterdam
            [berthVisit]="berthVisit"
            [berthVisitNumber]="$index"
            [harbourDuesDetails]="harbourDuesDetails()"
            [vesselDeadWeightKg]="vesselDeadWeightKg()"
            [showValidationErrors]="showValidationErrors()" />
        </li>
      }
    </ol>
  </div>
</div>
